<template lang="">
  <div class="content-container">
    <search-comp @onSearch="fnSearchUser" @onReset="fnResetUser">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Thông tin tìm kiếm</div>
                <div class="child-w-80">
                  <input
                    v-model="userSearchData.search_information"
                    type="text"
                    placeholder="Nhập thông tin"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-5">
              <div class="das-form-input">
                <div class="label"></div>
                <div class="checkbox-wrap" style="display: block !important">
                  <input
                    id="cpSpdTp3"
                    ref="checkboxSearch"
                    v-model="userSearchData.is_active"
                    type="checkbox"
                  />
                  <label for="cpSpdTp3"
                    >Hiển thị người dùng không hoạt động</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div v-loading="userLoading" style="height: 300px" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="userColumns"
        :rows="userRows"
        row-selection="single"
        class="agGrid"
        dom-layout="scroll"
        :row-multi-select-with-click="true"
        :auto-select-first-row="false"
        :auto-size-cell="true"
        @selectionChanged="selectionChangedUser"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="userPaging.totalPage"
        :page-num="userPaging.currentPage"
        @pageChanged="onPageChanged($event, 'userPaging')"
        @onPageSizeChange="onPageSizeChanged($event, 'userPaging')"
      />
    </div>
    <div class="button-containers">
      <button
        :disabled="selectedUserRow === null || disabledByLongTask"
        class="btn primary small"
        @click="onOpenDialog"
      >
        <span v-if="disabledByLongTask" class="load"></span>
        Gán phòng
      </button>
    </div>

    <!--Assign Room Dialog -->
    <el-dialog
      :title="`Chọn phòng cho nhân viên ${selectedUserRow?.full_name}`"
      :visible.sync="dialogAssignRoomVisible"
      :close-on-click-modal="false"
      width="70%"
      @close="fnCloseRoomDialog"
    >
      <div class="content-box">
        <div class="das-form-container">
          <!-- <div class="das-form-group">
            <validation-observer ref="assignRoomFormValidator">
              <div class="das-form-row">
                <div class="das-form-col col-6">
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('field.validTime') }}
                    </div>
                    <validation-provider
                      rules="required"
                      :name="$t('field.validTime')"
                    >
                      <div class="child-w-80">
                        <CalendarRange
                          v-model="validTime"
                          style="display: block; width: 100%"
                          mode="datetime"
                          :min-max="{
                            min: this.$moment()
                              .startOf('day')
                              .format('YYYY-MM-DD HH:mm')
                          }"
                        />
                      </div>
                    </validation-provider>
                  </div>
                </div>
              </div>
            </validation-observer>
          </div>
          <hr /> -->
          <div class="das-form-group">
            <div class="das-form-group-title">Danh sách phòng đã gán khóa</div>
            <search-comp @onSearch="fnSearchRoom" @onReset="fnResetRoom">
              <div class="das-form-container">
                <div class="das-form-group">
                  <div class="das-form-row">
                    <div class="das-form-col col-4">
                      <div class="das-form-input">
                        <div class="label">Số phòng</div>
                        <div class="child-w-80">
                          <input
                            v-model="roomSearchParams.roomNumber"
                            type="text"
                            placeholder="Nhập số phòng"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="das-form-col col-4">
                      <div class="das-form-input">
                        <div class="label">Khách sạn</div>
                        <div class="child-w-80">
                          <el-select
                            v-model="roomSearchParams.hotelId"
                            style="flex: 1"
                            placeholder="Chọn"
                          >
                            <el-option
                              v-for="(item, index) in hotelList"
                              :key="index"
                              :label="item.name"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                          <!-- <select
                          v-model="searchParams.hotelId"
                          placeholder="Chọn"
                        >
                          <option
                            v-for="(item, index) in hotelList"
                            :key="index"
                            :value="item.id"
                          >
                            {{ item.name }}
                          </option>
                        </select> -->
                        </div>
                      </div>
                    </div>
                    <div class="das-form-col col-4">
                      <div class="das-form-input">
                        <div class="label">Hạng phòng</div>
                        <div class="child-w-80">
                          <el-select
                            v-model="roomSearchParams.roomLevelId"
                            style="flex: 1"
                            placeholder="Chọn"
                          >
                            <el-option
                              v-for="(item, index) in roomLevelList"
                              :key="index"
                              :label="item.name"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                          <!-- <select
                          v-model="searchParams.roomLevelId"
                          placeholder="Chọn"
                        >
                          <option
                            v-for="(item, index) in hotelList"
                            :key="index"
                            :value="item.id"
                          >
                            {{ item.name }}
                          </option>
                        </select> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </search-comp>
            <div class="section-box">
              <div class="das-form-container">
                <div
                  v-loading="roomLoading"
                  class="das-form-group"
                  style="height: 300px"
                >
                  <GridVx
                    ref="roomTable"
                    dom-layout="scroll"
                    :columns="roomColumns"
                    :rows="roomRows"
                    :context="context"
                    class="agGrid"
                    :auto-size-cell="true"
                    :row-multi-select-with-click="true"
                    @selectionChanged="onSelectRoom"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="placeholder">Chọn thời gian hiệu lực</div>

        <div class="button-containers">
          <div class="flex" style="flex: 0.6">
            <!-- <el-select
              v-model="selectValue"
              placeholder="Chọn thời gian hiệu lực"
              @change="selectChange(selectValue)"
            >
              <el-option label="6 tháng" value="6MM"> </el-option>
              <el-option label="1 năm" value="1YYYY"> </el-option>
              <el-option label="3 năm" value="3YYYY"> </el-option>
            </el-select> -->

            <CalendarRange
              v-model="validTime"
              style="display: block; width: 100%"
              mode="datetime"
              :min-max="{
                min: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm')
              }"
            />

            <button
              :disabled="
                selectedRoom.length <= 0 || selectedRoomIndex.length <= 0
              "
              style="width: 150px"
              class="btn primary small ml-10"
              @click="onApplyDateRange"
            >
              Áp dụng
            </button>
          </div>
          <div>
            <button
              class="btn primary small outline"
              @click="fnCloseRoomDialog"
            >
              Đóng
            </button>
            <button
              :disabled="roomRows.length === 0"
              class="btn primary small ml-10"
              @click="fnAssignRoom"
            >
              Xác nhận
            </button>
          </div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import { getUserApi } from '@/api/userConfig/user'
import { getHotelListApi } from '@/api/booking_service/bookingGroup'
import { getListRoomApi } from '@/api/Room/room'
import { getListRoomLevelApi } from '@/api/Room/roomLevel'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import { CellRenderCalendarSelectForTable } from '@/utils/groupCellRenders.js'
import { CellRenderDeleteIcon } from '@/utils/cellRenders.js'
import { assignUserToRoom } from '@/api/reception/card_service.js'
import { checkRunningTask } from '@/api/task'

export default {
  components: {
    CalendarRange,
    CellRenderCalendarSelectForTable,
    CellRenderDeleteIcon
  },
  data() {
    return {
      context: null,
      userLoading: false,
      roomLoading: false,
      dialogAssignRoomVisible: false,

      userSearchData: {
        search_information: null,
        is_active: true,
        idCard: true,
        page_num: 1,
        page_size: 10
      },
      userSearchDataDefault: {
        search_information: null,
        is_active: true,
        idCard: true,
        page_num: 1,
        page_size: 10
      },
      userRows: [],
      userColumns: [
        {
          headerName: 'ID Nhân viên',
          headerTooltip: 'ID Nhân viên',
          tooltipField: 'code',
          field: 'code'
        },
        {
          headerName: 'Tên đăng nhập',
          headerTooltip: 'Tên đăng nhập',
          tooltipField: 'username',
          field: 'username'
        },
        {
          headerName: 'Họ và tên',
          headerTooltip: 'Họ và tên',
          tooltipField: 'full_name',
          field: 'full_name'
        },
        {
          headerName: 'Bộ phận',
          tooltipField: 'department_name',
          field: 'department_name'
        },

        {
          headerName: 'Nhóm người dùng',
          headerTooltip: 'Nhóm người dùng',
          tooltipField: 'user_group_name',
          field: 'user_group_name',
          minWidth: 400
        }
      ],
      userPaging: {
        totalPage: 0,
        currentPage: 0
      },
      selectedUserRow: null,
      disabledByLongTask: false,

      roomRows: [],
      roomColumns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
          // headerClass: 'header-row-span-2'
        },
        {
          headerName: 'Khách sạn',
          field: 'hotel_nm',
          headerTooltip: 'Khách sạn',
          tooltipField: 'hotel_nm',
          minWidth: 100
          // headerClass: 'header-row-span-2'
        },
        {
          headerName: 'Hạng phòng',
          field: 'room_level_name',
          headerTooltip: 'Hạng phòng',
          tooltipField: 'room_level_name',
          minWidth: 100
          // headerClass: 'header-row-span-2'
        },
        {
          headerName: 'Số phòng',
          field: 'room_num',
          tooltipField: 'room_num',
          minWidth: 100
          // headerClass: 'header-row-span-2'
        },
        {
          headerName: 'Ngày bắt đầu',
          tooltipField: 'card_number_start_date',
          field: 'card_number_start_date',
          cellRenderer: 'CellRenderCalendarSelectForTable',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'card_number_start_date',
              clearable: true,
              dateType: 'datetime',
              format: 'dd/MM/yyyy HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss'
            }
          },
          minWidth: 150,
          maxWidth: 250
        },
        // format: 'dd/MM/yyyy HH:mm:ss',
        // valueFormat: 'yyyy-MM-dd HH:mm:ss'
        {
          headerName: 'Ngày hết hạn',
          tooltipField: 'card_number_end_date',
          field: 'card_number_end_date',
          cellRenderer: 'CellRenderCalendarSelectForTable',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'card_number_end_date',
              clearable: true,
              dateType: 'datetime',
              format: 'dd/MM/yyyy HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss'
            }
          },
          minWidth: 150,
          maxWidth: 250
        },
        // {
        //   headerName: 'Hiệu lực',
        //   children: []
        // }
        {
          headerName: '',
          // headerClass: ['header-row-span-2', 'header-cell-suffix-group'],
          width: 50,
          cellRenderer: 'CellRenderDeleteIcon',
          cellRendererParams: params => {
            return {
              refName: 'freeCard',
              disabled: !!params.data?.card_id
            }
          },
          cellStyle: () => {
            return {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }
          }
        }
      ],
      // roomPaging: {
      //   totalPage: 0,
      //   currentPage: 0
      // },
      roomSearchParams: {
        roomNumber: null,
        hotelId: null,
        roomLevelId: null
      },
      roomSearchParamsDefault: {
        roomNumber: null,
        hotelId: null,
        roomLevelId: null
      },
      roomLevelList: [],
      hotelList: [],
      selectedRoom: [],
      selectedRoomIndex: [],
      form: {
        startTime: this.$moment().format('YYYY-MM-DD HH:mm'),
        expireTime: this.$moment().add(1, 'y').format('YYYY-MM-DD HH:mm')
      }
    }
  },
  computed: {
    validTime: {
      get() {
        return {
          start: this.form.startTime,
          end: this.form.expireTime
        }
      },
      set(val) {
        this.form.startTime = val.start
        this.form.expireTime = val.end
      }
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  mounted() {
    this.fnSearchUser()
    this.fnGetHotelListApi()
    this.getRoomLevelOptions()
  },

  methods: {
    // handle event
    onPageChanged(pageNum, field) {
      switch (field) {
        case 'userPaging':
          this.userSearchData.page_num = pageNum
          this.fnSearchUser()
          break
        default:
          break
      }
    },
    onPageSizeChanged(pageSize, field) {
      switch (field) {
        case 'userPaging':
          this.userSearchData.page_size = pageSize
          this.userSearchData.page_num = 1
          this.fnSearchUser()
          break
        default:
          break
      }
    },
    async fnSearchUser() {
      this.userLoading = true
      this.userSearchData.page_num = 1
      await getUserApi(this.userSearchData)
        .then(res => {
          var data = res.data
          this.userRows = data.map(item => {
            return {
              ...item.account,
              user_group_name: item.user_groups.map(item1 => {
                return item1.name
              }),
              department_name: item.account.department.map(item1 => {
                return item1.name
              })
            }
          })
          this.userPaging.totalPage = Math.ceil(
            res.total / this.userSearchData.page_size
          )
          this.userPaging.currentPage = this.userSearchData.page_num
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {
          this.userLoading = false
        })
    },
    fnResetUser() {
      this.userSearchData = Object.assign({}, this.userSearchDataDefault)
      this.fnSearchUser()
    },
    async selectionChangedUser(select) {
      this.selectedUserRow = select[0] || null
      this.disabledByLongTask = await checkRunningTask(select[0]?.id, 'STAFF')
    },

    // handle assign dialog event + api call
    async fnGetHotelListApi() {
      await getHotelListApi()
        .then(res => {
          this.hotelList = res.data
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {})
    },
    async getRoomLevelOptions() {
      const data = await getListRoomLevelApi()
      this.roomLevelList = data?.data || []
    },

    async fnSearchRoom() {
      this.roomLoading = true
      var params = {
        ...this.roomSearchParams,
        cardNumber: this.selectedUserRow.id_card,
        isAssignLock: true
      }
      await getListRoomApi(params)
        .then(res => {
          this.roomRows = res.data
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {
          this.roomLoading = false
        })
    },
    fnResetRoom() {
      this.roomSearchParams = Object.assign({}, this.roomSearchParamsDefault)
    },
    onSelectRoom(select) {
      this.selectedRoom = select
      this.selectedRoomIndex = this.selectedRoom.map(item => {
        return this.roomRows.findIndex(row => row.id === item.id)
      })
    },
    changeCalendar(params, value, colName) {
      const idx = params.rowIndex
      this.roomRows[idx][colName] = value
    },
    onDeleteIconClicked(params) {
      params.node.setSelected(false)
      this.roomRows.splice(params.rowIndex, 1, {
        ...params.data,
        card_number_start_date: null,
        card_number_end_date: null
      })
    },
    onApplyDateRange() {
      for (let i of this.selectedRoomIndex) {
        this.roomRows.splice(i, 1, {
          ...this.roomRows[i],
          card_number_start_date: `${this.$moment(this.validTime.start).format(
            'YYYY-MM-DD HH:mm'
          )}:00`,
          card_number_end_date: `${this.$moment(this.validTime.end).format(
            'YYYY-MM-DD HH:mm'
          )}:00`
        })
      }
    },

    async fnAssignRoom() {
      this.roomLoading = true
      // if (
      //   (await this.$vxForm.isValid(this.$refs.assignRoomFormValidator)) ===
      //   false
      // ) {
      //   return
      // }
      var req = this.roomRows.filter(item => {
        return item.card_number_start_date && item.card_number_end_date
      })
      var isValid = true
      for (var i = 0; i < req.length; i++) {
        if (
          // this.$moment(req[i].card_number_start_date).isBefore(
          //   this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
          // ) ||
          this.$moment(req[i].card_number_start_date).isAfter(
            req[i].card_number_end_date
          )
        ) {
          isValid = false
          break
        }
      }

      if (!isValid) {
        this.$message({
          type: 'error',
          message: 'Vui lòng xem lại thời gian hiệu lực'
        })
        this.roomLoading = false
        return
      }
      var data = {
        ...this.roomSearchParams,
        card_number: this.selectedUserRow.id_card,
        card_name: this.selectedUserRow.username,
        room_list: req.map(item => {
          return {
            lock_id: item.lock_id,
            room_id: item.id,
            start_date: item.card_number_start_date,
            end_date: item.card_number_end_date
          }
        })
      }
      var params = {
        staffId: this.selectedUserRow.id
      }
      await assignUserToRoom(data, params)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${res.message}`)
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(async () => {
          // await this.getListRoomApi()
          this.dialogAssignRoomVisible = false
          this.roomSearchParams = Object.assign(
            {},
            this.roomSearchParamsDefault
          )
          this.roomLoading = false
        })
    },
    async onOpenDialog() {
      await this.fnSearchRoom()
      this.dialogAssignRoomVisible = true
    },
    fnCloseRoomDialog() {
      this.selectedRoom = []
      this.dialogAssignRoomVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dialog__footer .button-containers {
  justify-content: space-between !important;
}

.el-dialog__footer .placeholder {
  text-align: left;
  font-size: small;
  padding-bottom: 3px;
  color: #606266;
}
</style>
